import React, { useContext, useCallback } from 'react';
import Board from './Board/Board';
import Panel from './Panel/Panel';
import Options from './Options/Options';
import Button from '@Mui/material/Button';
import GameConfigContext from '../../contexts/GameConfigContext/GameConfigContext';
import ConfigContext from '../../contexts/ConfigContext/ConfigContext';
import { displayTime } from '../ChooseGame/functions';
import { GameBox, WinBox, WinBoxInner } from './Game.css';

const Game = (): JSX.Element => {
  const { gameConfig, setGameConfig, loadNewGame } = useContext(GameConfigContext);
  const { config, setConfig } = useContext(ConfigContext);

  const handleGoToMenu = useCallback(() => {
    setGameConfig({...gameConfig, gameOver: false, win: false, gameTime: 0, started: false, reloaded: !gameConfig.reloaded});
    setConfig({...config, openGameChooser: true});
  }, []);

  const handlePlayAgain = useCallback(() => {
    loadNewGame();
  }, [gameConfig]);

  return (
    <GameBox width={gameConfig.tileBoardWidth}>
      {(gameConfig.gameOver && gameConfig.win && gameConfig.gameTime) &&
        <WinBox>
          <WinBoxInner>
            <div style={{color: '#2e7d32', textAlign: 'center'}}><i className="fa fa-trophy" /> YOU WON!</div>
            <div style={{fontSize: 13, marginTop: 10, textAlign: 'center'}}><i className="fa fa-clock" /> {displayTime(gameConfig.gameTime)}</div>
            <div style={{marginTop: 10}}>
              <Button variant="contained" color="primary" sx={{padding: 0, fontSize: 12}} onClick={handlePlayAgain}>
                <div style={{padding: 5}}>PLAY AGAIN</div>
              </Button>
              <Button variant="contained" color="error" sx={{padding: 0, fontSize: 12, marginLeft: '5px'}} onClick={handleGoToMenu}>
                <div style={{padding: 5}}>GO TO MENU</div>
              </Button>
            </div>
          </WinBoxInner>
        </WinBox>
      }
      <Options />
      <Panel />
      <Board />
    </GameBox>
  );
};

export default Game;